// extracted by mini-css-extract-plugin
module.exports = {"AchievementList":"styles_AchievementList__10kOD","AchievementList_type":"styles_AchievementList_type__2I20R","title":"styles_title__2pDRb"};